import React, { useEffect, useState } from "react";
import sliderInner from '../assets/images/innerSlide01.jpg';
import inrSlr1 from '../assets/images/homepage-banner-fancy-flyer1.png';
import inrSlr2 from '../assets/images/homepage-banner-fancy-flyer2.png';
import inrSlr3 from '../assets/images/homepage-banner-fancy-flyer3.png';
import leafIcn from "../assets/images/slider-shape-5.png";
import CommonViewtheme from '../Components/CommonViewTheme';
import { FaHandPointRight } from "react-icons/fa";
import ThemeBaseRouting from "helper/ThemeBaseRouting";
import { useNavigate, Link } from "react-router-dom";
import subThemes from "../helper/SubThemes_List"

function CourseDes() {
  const navigate = useNavigate();
  const [contentToDisplay, setContentToDisplay] = useState("No content available"); 

  useEffect(() => {
    const themeName = localStorage.getItem('theme_name'); // Fetch theme from local storage
    const selectedSubTheme = localStorage.getItem('sub_themes'); // Fetch selected sub-theme from local storage

    if (themeName && selectedSubTheme) {
      const subThemeList = subThemes[themeName] || [];
      const foundSubTheme = subThemeList.find(subTheme => subTheme.value === selectedSubTheme); // Find the selected sub-theme
      if (foundSubTheme) {
        setContentToDisplay(foundSubTheme.content); // Set content based on the selected sub-theme
      } else {
        setContentToDisplay("No content available"); // Fallback content
      }
    } else {
      setContentToDisplay("No content available"); // Fallback content if theme or sub-theme is not found
    }
  }, []); // Run once on component mount

  const handleRoute = (name, url) => {
    localStorage.setItem('theme_name', name);
    navigate(url);
  };

  return (
    <>
      <section className="sliderSec sliderInnerSec">
        <img src={sliderInner} alt="" />
        <div className="sliderInrHdng">
          {/* <h2>Eco Clubs <span className="hdngBrkr">for Mission LiFE Themes</span> Themes</h2> */}
          <h2>Eco Clubs <span className="hdngBrkr">for Mission LiFE Themes</span></h2>
        </div>
      </section>
      <section className='courseDesSec'>
        <div className='courserDesSecSldr'>
          <div className='detlSlrIcn1'><img src={inrSlr1} alt="" /></div>
          <div className='detlSlrIcn2'><img src={inrSlr2} alt="" /></div>
          <div className='detlSlrIcn3'><img src={inrSlr3} alt="" /></div>
          <div className='container-fluid'>
            <div className="backBtndiv">
            <button className="button green btn-login-signup loginBtnnewhm impctBtn" onClick={()=>navigate(-1)} >Back</button>
              {/* <a href="/details" className="button green btn-login-signup loginBtnnewhm impctBtn">Back</a> */}
            </div>
            <div className='col-12 courseDesSldrLft'>
              <h2 className='detlHdng'>Overarching Objectives & Goals:</h2>
              <p style={{ whiteSpace: "pre-line" }}>{contentToDisplay}</p>

            </div>
          </div>
        </div>
        <div className='courseDesSecBtmCnt'>
          <div className='container-fluid'>
            <div className='row'>
              <div className='col-12 courseDesCntLft'>
               
                <div className='skillLrn'>
                  <ul>
                    {ThemeBaseRouting.map((theme, i) => (
                      <li onClick={() => handleRoute(theme.lable, theme.url)}><Link className="flex">{theme.lable}</Link></li>
                    ))}
                  </ul>
                </div>

              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="stackHolderSec detailPagGalrysec">
        <img className="slider__shape-13 stackholdrLf" src={leafIcn} alt="" />
        <div className="container">
          <span className="contact__shape-1"></span>
          <div className="imageListShowDiv">
            <CommonViewtheme />
          </div>
        </div>
      </section>
    </>
  )
}

export default CourseDes;